var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicFilled = function SvgMicFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.578 9V4.531h-.005a2.578 2.578 0 0 0-5.146 0h-.005V9a2.578 2.578 0 1 0 5.156 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.047 6.542c.285 0 .516.231.516.516V9a3.438 3.438 0 0 0 6.875 0V7.058a.516.516 0 0 1 1.03 0V9a4.468 4.468 0 0 1-3.952 4.439v1.405h1.546a.516.516 0 1 1 0 1.031H6.938a.516.516 0 1 1 0-1.031h1.547v-1.405A4.469 4.469 0 0 1 4.531 9V7.058c0-.285.231-.516.516-.516Z"
  })));
};
export default SvgMicFilled;